export const PROGRAM_BENEFITS_2_CONSTANTS = {
    FIELDS_CONFIG: [
        {
            fieldName: "desktop_background_color",
            label: "Desktop Background Color",
            value: "#FFFFFF",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter desktop background color (e.g., #FFFFFF)",
            required: false,
            defaultValue: "#FFFFFF",
        },
        {
            fieldName: "mobile_background_color",
            label: "Mobile Background Color",
            value: "#FFFFFF",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter mobile background color (e.g., #FFFFFF)",
            required: false,
            defaultValue: "#FFFFFF",
        },
        {
            fieldName: "backvariant",
            label: "Background Variant",
            value: "variant_1",
            valueType: "string",
            filedType: "SELECT",
            placeholder: "Select Background Variant",
            required: true,
            defaultValue: "variant_1",
            className: "h-9 py-1.5 text-sm",
            iconClassName: "!size-4",
            options: [
                { label: "Variant 1", value: "variant_1" },
                { label: "Variant 2", value: "variant_2" },
                { label: "Variant 3", value: "variant_3" },
            ],
        },
        {
            fieldName: "gradient_color_1",
            label: "Gradient Color 1",
            value: "rgba(0, 212, 235, 0.33)",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter Gradient Color 1",
            required: false,
            defaultValue: "rgba(0, 212, 235, 0.33)",
        },
        {
            fieldName: "gradient_color_2",
            label: "Gradient Color 2",
            value: "rgba(0, 0, 0, 0.66)",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter Gradient Color 2",
            required: false,
            defaultValue: "rgba(0, 0, 0, 0.66)",
        },
        {
            fieldName: "gradient_color_3",
            label: "Gradient Color 3",
            value: "rgba(0, 0, 0, 0.66)",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter Gradient Color 3",
            required: false,
            defaultValue: "rgba(0, 0, 0, 0.66)",
        },
        {
            fieldName: "gradient_color_4",
            label: "Gradient Color 4",
            value: "rgba(83, 69, 195, 0.46)",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter Gradient Color 4",
            required: false,
            defaultValue: "rgba(83, 69, 195, 0.46)",
        },
        {
            fieldName: "pre_title",
            label: "Pre Title (max 20 characters)",
            value: "Graduate with globally recognized",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Max 20 characters",
            required: false,
            defaultValue: "Why Choose ",
        },
        {
            fieldName: "pre_title_color",
            label: "Pre Title Color",
            value: "#222222CC",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter pre title color (e.g., #222222CC)",
            required: false,
            defaultValue: "#222222CC",
        },
        {
            fieldName: "title",
            label: "Title (max 20 characters)",
            value: "This Program.",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Max 20 characters",
            required: true,
            defaultValue: "This Program",
        },
        {   
            fieldName: "title_start_color",
            label: "Title Start Color (Gradient)",
            value: "#FFFFFF",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "#FFFFFF",
            required: false,
            defaultValue: "#FFFFFF",
        },
        {
            fieldName: "title_end_color",
            label: "Title End Color (Gradient)",
            value: "#00D4EB",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "#00D4EB",
            required: false,
            defaultValue: "#00D4EB",
        },
        {
            fieldName: "title_gradient_direction",
            label: "Title Gradient Angle",
            value: "90deg",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "e.g., '90deg'",
            required: false,
            defaultValue: "90deg",
        },
        {
            fieldName: "description",
            label: "Description (max 250 characters)",
            value: "This program is designed to help you achieve your goals.",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Max 250 characters",
            required: false,
            defaultValue: "This program is designed to help you achieve your goals.",
        },
        {
            fieldName: "description_color",
            label: "Description Color",
            value: "#FFFFFFAF",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "#FFFFFFAF",
            required: false,
            defaultValue: "#FFFFFFAF",
        },
        {
            fieldName: "left_navigation_icon",
            label: "Left Navigation Icon",
            value: "",
            valueType: "string",
            filedType: "FILE",
            placeholder: "Upload Left Navigation Icon",
            required: false,
            defaultValue: "",
        },
        {
            fieldName: "alt_text_left_nav_icon",
            label: "Alt Text for Left Navigation Icon",
            value: "",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter alt text for left navigation icon",
            required: false,
            defaultValue: "",
        },
        {
            fieldName: "right_navigation_icon",
            label: "Right Navigation Icon",
            value: "",
            valueType: "string",
            filedType: "FILE",
            placeholder: "Upload Right Navigation Icon",
            required: false,
            defaultValue: "",
        },
        {
            fieldName: "alt_text_right_nav_icon",
            label: "Alt Text for Right Navigation Icon",
            value: "",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter alt text for right navigation icon",
            required: false,
            defaultValue: "",
        },
        {
            fieldName: "scroll_frequency",
            label: "Scroll Frequency",
            value: "",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter scroll frequency in ms (e.g., 3000)",
            required: false,
            defaultValue: "",
        },
        {
            fieldName: "enable_animation",
            label: "Enable Animation",
            value: false,
            valueType: "boolean",
            filedType: "TOGGLE",
            placeholder: "Enable animation on this card",
            required: false,
            defaultValue: false,
        },
        {
            fieldName: "enable_stack_carousel",
            label: "Enable Stack Carousel",
            value: false,
            valueType: "boolean",
            filedType: "TOGGLE",
            placeholder: "Use the stacked carousel on desktop instead of the default carousel",
            required: false,
            defaultValue: false,
        },
    ],

    METADATA_FIELDS: [
        {
            header: "Image",
            fieldName: "meta_image",
            value: "",
            valueType: "string",
            filedType: "FILE",
            placeholder: "Upload Image",
        },
        {
            header: "Alt Image",
            fieldName: "meta_alt_image",
            value: "",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter Alt Image Text",
        },
        {
            header: "Video link (YouTube)",
            fieldName: "meta_video_link",
            value: "",
            valueType: "string",
            filedType: "INPUT",
            placeholder:
                "Optional — full YouTube URL (watch, youtu.be, or embed). Shows a play button on the card image.",
            required: false,
            defaultValue: "",
        },
        {
            header: "Title (max 45 characters)",
            fieldName: "meta_title",
            value: "",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Max 45 characters",
            required: true,
        },
        {
            header: "Title Color",
            fieldName: "meta_title_color",
            value: "#222222",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter Title Color",
            defaultValue: "#222222",
        },
        {
            header: "Sub Title (max 190 characters)",
            fieldName: "meta_sub_title",
            value: "",
            valueType: "string",
            filedType: "TEXT_AREA",
            placeholder: "Max 190 characters",
        },
        {
            header: "Sub Title Color",
            fieldName: "meta_sub_title_color",
            value: "#FFFFFF",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter Sub Title Color",
            defaultValue: "#FFFFFF",
        },
        {
            header: "Priority",
            fieldName: "meta_priority",
            value: 1,
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter Priority",
            required: true,
        },
        {
            header: "Card Blur Effect",
            fieldName: "meta_card_blur_effect",
            value: false,
            valueType: "boolean",
            filedType: "TOGGLE",
            placeholder: "Enable blur effect on this card",
            defaultValue: false,
        }
    ],

    DEFAULT_ROW: {
        id: "1",
        meta_image: "",
        meta_alt_image: "",
        meta_video_link: "",
        meta_title: "",
        meta_title_color: "#FFFFFF",
        meta_sub_title: "",
        meta_sub_title_color: "#FFFFFF",
        meta_priority: "1",
        meta_card_blur_effect: false,
    },
} as const;